<template>
  <div
    class="ChargeCardAuthorizationForm"
    style="background-color: rgb(238, 238, 238)"
  >
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" xl="6">
          <v-card color="transparent">
            <v-card-title class="text-center">
              <div class="text-center mx-auto">
                <span class="bold product-title pr-2">Charge Card </span>
                <span class="product-title"> Authorization Form</span>
              </div>
            </v-card-title>

            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="Email Address:"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="project"
                      label="Project/Client Reference:"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="name"
                      :rules="required"
                      label="Name"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="invoiceRefereence"
                      label="Invoice Refereence"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="cardName"
                      :rules="required"
                      label="Name on card"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-radio-group
                      v-model="radioGroup"
                      label="Credit Card Type"
                      :rules="required"
                      color="grey"
                    >
                      <v-radio
                        label="American Express"
                        value="American Express"
                        color="grey"
                      ></v-radio>
                      <v-radio
                        label="Mastercard"
                        value="Mastercard"
                        color="grey"
                      ></v-radio>
                      <v-radio label="Visa" value="Visa" color="grey"></v-radio>
                      <v-radio
                        label="Other"
                        value="Other"
                        color="grey"
                      >
                      
                      </v-radio>
                    </v-radio-group>

                    <template v-if="radioGroup == 'Other'">
                      <v-text-field
                        v-model="otherCard"
                        label="Credit Card Type"
                        color="grey"
                        class="pt-0"
                      ></v-text-field>
                    </template>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="cardNumber"
                      :rules="required"
                      label="Credit Card Number"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="securityCode"
                      :rules="required"
                      label="Security Code"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="expirationDate"
                      :rules="required"
                      label="Expiration Date"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="6">
                    <v-text-field
                      v-model="billingAddress"
                      :rules="required"
                      label="Billing Address"
                      color="gray"
                    ></v-text-field>
                  </v-col> -->
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="streetAddress"
                      label="Street Address"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="city"
                      label="City"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="state"
                      label="State"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="zipCode"
                      :rules="required"
                      label="Zip Code"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label="Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          color="grey"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="date"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save"
                        color="grey"
                      ></v-date-picker>
                    </v-menu>
                  </v-col> -->
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions class="py-0 px-0">
              <v-btn
                color="black"
                block
                dark
                tile
                class="mr-4"
                @click="validate"
                :ripple="false"
                elevation="0"
              >
                send &nbsp; <span class="bold white--text ml-1">request</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default {
  data() {
    return {
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      required: [(v) => !!v || "Required"],
      email: "",
      project: "",
      name: "",
      invoiceRefereence: "",
      cardName: "",
      radioGroup: "",
      cardNumber: "",
      securityCode: "",
      expirationDate: "",
      billingAddress: "",
      streetAdress: "",
      city: "",
      state: "",
      zipCode: "",
      date: "",
      otherCard: ""
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    radioGroup: function () {
      this.otherCard = '';
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    validate() {
      if (this.$refs.form.validate()) {
        var aux = this;

        let data = {
          Email: aux.email,
          Project: aux.project,
          Name: aux.name,
          InvoiceReference: aux.invoiceRefereence,
          CardName: aux.cardName,
          CreditCardType: aux.radioGroup,
          OtherCard: aux.otherCard,
          CardNumber: aux.cardNumber,
          SecurityCode: aux.securityCode,
          ExpirationDate: aux.expirationDate,
          Street: aux.streetAdress,
          City: aux.city,
          State: aux.state,
          ZipCode: aux.zipCode,
          Date: aux.date,
        };

        fetch(
          "https://www.artlesscms.actstudio.xyz/api/forms/submit/ChargeCardAuthorizationForm?token=cf00a9204acb3ab54e671ca7655e5f",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              form: data,
            }),
          }
        )
          .then((entry) => entry.json())
          .then((entry) => console.log(entry))
          .then(this.copiaCollection(data))
          .then(this.reiniciar());
      }
    },
    copiaCollection: function (formData){
      fetch('https://www.artlesscms.actstudio.xyz/api/collections/save/ChargeCardAuthorizationForm', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              data: formData
          })
      })
      .then(res=>res.json());
    },
    reiniciar: function () {
      this.$emit("openSnackbar");

      this.$router.push("/");
    },
  },
};
</script>